import { useEffect } from 'react';
// ---- external imports ----


const useMountEffect = (fun) => useEffect(fun, []);


export default useMountEffect;
